var ymmproduct = window.ymmApiBaseUrl || 'https://partsology.com/apps/ymm-dev';
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tabs li a');
  const contents = document.querySelectorAll('.tab-content');

  tabs.forEach((tab) => {
    tab.addEventListener('click', function (event) {
      event.preventDefault();

      tabs.forEach((t) => t.classList.remove('active'));
      contents.forEach((c) => c.classList.remove('active'));

      this.classList.add('active');
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.classList.add('active');
      }
    });
  });
});

if (window.location.href.includes('products')) {
  // Function to strip underscore and numbers from SKU
  function getBaseSku(sku) {
    if (!sku) return sku;
    // Remove underscore and everything after it (e.g., "OP900_15" -> "OP900")
    return sku.split('_')[0];
  }

  // Function to find base product ID from base SKU (same logic as Alpine.js version)
  async function findBaseProductId(baseSku) {
    try {
      console.log('Product page: Searching for base product with SKU:', baseSku);
      
      // Try multiple pages to find the base product
      for (let page = 1; page <= 15; page++) {
        console.log('Product page: Searching page', page, 'for base product:', baseSku);
        
        const searchUrl = new URL(window.location.origin + '/search');
        searchUrl.searchParams.append('type', 'product');
        searchUrl.searchParams.append('q', baseSku);
        if (page > 1) {
          searchUrl.searchParams.append('page', page);
        }
        
        const response = await fetch(searchUrl);
        const html = await response.text();
        
        // Parse the HTML to find the base product (one without underscore)
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productCards = doc.querySelectorAll('[x-data*="buyerGuide"]');
        
        console.log('Product page: Found', productCards.length, 'products on page', page);
        
        for (const card of productCards) {
          const xDataAttr = card.getAttribute('x-data');
          const match = xDataAttr.match(/buyerGuide\('(\d+)',\s*'([^']+)'\)/);
          if (match) {
            const [, productId, sku] = match;
            // Find the product with exact base SKU (no underscore)
            if (sku === baseSku) {
              console.log('Product page: Found base product ID:', productId, 'for SKU:', baseSku, 'on page', page);
              return productId;
            }
          }
        }
        
        // If no more products on this page, stop searching
        if (productCards.length === 0) {
          console.log('Product page: No more products found on page', page, '- stopping search');
          break;
        }
      }
      
      console.log('Product page: Base product ID not found for SKU:', baseSku, 'after searching multiple pages');
      return null;
    } catch (error) {
      console.error('Product page: Error finding base product ID:', error);
      return null;
    }
  }

  // Enhanced function to fetch compatibility data with underscore product support
  async function fetchCompatibilityData(sku, isRetry = false, productId = null, baseProductId = null) {
    console.log('Product page: Fetching compatibility data for:', productId || sku, 'isRetry:', isRetry);
    
    $.getJSON(ymmproduct, {
      type: 'ajax',
      request: 'compatibility',
      product: baseProductId || productId || sku,
      dataType: 'json',
    }).done(function (data) {
      console.log('Product page: API Response for product "' + (baseProductId || productId || sku) + '":', data);
      var list_html = '';
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          list_html +=
            '<tr><td class="whitespace-nowrap">' +
            data[i]['value_name4'] +
            '</td><td class="whitespace-nowrap">' +
            data[i]['value_name3'] +
            '</td><td class="whitespace-nowrap">' +
            data[i]['value_name2'] +
            '</td><td class="whitespace-nowrap">' +
            data[i]['value_name1'] +
            '</td></tr>';
        }
        $('.compatibility-table').html(list_html);
      } else {
        // If no results and this is not a retry, try with original SKU
        if (!isRetry) {
          var originalSku = $('.shop_product_sku').val();
          if (originalSku && originalSku !== sku) {
            console.log('Product page: No results for "' + (baseProductId || productId || sku) + '", trying original SKU "' + originalSku + '"');
            fetchCompatibilityData(originalSku, true, productId);
            return;
          }
        }
        $('.compatibility-table').html('<tr><td colspan="4" style="text-align:center">No results found!</td></tr>');
      }
    }).fail(function(jqXHR, textStatus, errorThrown) {
      console.error('Product page: Error fetching compatibility data for "' + (baseProductId || productId || sku) + '":', textStatus, errorThrown);
      
      // If this was the first attempt and it failed, try with original SKU
      if (!isRetry) {
        var originalSku = $('.shop_product_sku').val();
        if (originalSku && originalSku !== sku) {
          console.log('Product page: API error for "' + (baseProductId || productId || sku) + '", trying original SKU "' + originalSku + '"');
          fetchCompatibilityData(originalSku, true, productId);
          return;
        }
      }
      $('.compatibility-table').html('<tr><td colspan="4" style="text-align:center">No results found!</td></tr>');
    });
  } 

  // Main initialization logic
  var product_id = $('.shop_product_id').val();
  var product_sku = $('.shop_product_sku').val();
  
  if (product_id || product_sku) {
    console.log('Product page: Product ID: "' + product_id + '", Original SKU: "' + product_sku + '"');
    
    // Check if this is an underscore product
    if (product_sku && product_sku.includes('_')) {
      var base_sku = getBaseSku(product_sku);
      console.log('Product page: SKU contains underscore, finding base product ID for SKU:', base_sku);
      
      // Find base product ID first
      findBaseProductId(base_sku).then(function(baseProductId) {
        if (baseProductId) {
          console.log('Product page: Using base product ID:', baseProductId);
          fetchCompatibilityData(base_sku, false, product_id, baseProductId);
        } else {
          console.log('Product page: Base product ID not found, trying with base SKU:', base_sku);
          fetchCompatibilityData(base_sku, false, product_id);
        }
      }).catch(function(error) {
        console.error('Product page: Error in findBaseProductId:', error);
        // Fallback to original logic
        var base_sku = getBaseSku(product_sku);
        fetchCompatibilityData(base_sku, false, product_id);
      });
    } else {
      // Regular product without underscore - use original logic
      var base_sku = getBaseSku(product_sku);
      fetchCompatibilityData(base_sku, false, product_id);
    }
  } else {
    console.error('Product page: Product ID and SKU not found');
    $('.compatibility-table').html('<tr><td colspan="4" style="text-align:center">No results found!</td></tr>');
  }
}
